import { Controller } from "@hotwired/stimulus"

// Says so when a Turbo request cannot leave (network down): "Contacter la galerie" (inquiries/new)
// and the simulator's steps (simulators/show). What was typed stays, nothing to type again.
export default class extends Controller {
  static targets = ["error"]

  declare readonly errorTarget: HTMLElement

  sending() {
    this.errorTarget.hidden = true
  }

  failed() {
    this.errorTarget.hidden = false
  }
}
